import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1421fdc0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "navigation" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("ul", null, [
    /*#__PURE__*/ _createElementVNode("li", null, [
        /*#__PURE__*/ _createElementVNode("a", { href: "#contact" }, "CONTACT US")
    ]),
    /*#__PURE__*/ _createElementVNode("li", null, [
        /*#__PURE__*/ _createElementVNode("a", { href: "#portfolio" }, "PORTFOLIO")
    ]),
    /*#__PURE__*/ _createElementVNode("li", null, [
        /*#__PURE__*/ _createElementVNode("a", { href: "#services" }, "SERVICES")
    ]),
    /*#__PURE__*/ _createElementVNode("li", null, [
        /*#__PURE__*/ _createElementVNode("a", { href: "#about" }, "ABOUT")
    ])
], -1));
const _hoisted_3 = [
    _hoisted_2
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("nav", _hoisted_1, _hoisted_3));
}
